import { SourcedCandidateStatus } from 'generated-graphql/types';
import { SourcedCandidateQueryItem } from 'modules/sourcing-external/types/SourcedCandidateQueryItem';

export const splitSourcedCandidates = (
  sourcedCandidates: SourcedCandidateQueryItem[]
) => {
  const [awaitingEnrichmentSourcedCandidates, alreadyInvitedSourcedCandidates] =
    sourcedCandidates.reduce(
      (acc, candidate) => {
        if (candidate.status === SourcedCandidateStatus.AwaitingEnrichment) {
          acc[0].push(candidate);
        } else {
          acc[1].push(candidate);
        }
        return acc;
      },
      [[], []] as SourcedCandidateQueryItem[][]
    );

  return {
    awaitingEnrichmentSourcedCandidates,
    alreadyInvitedSourcedCandidates
  };
};
